module.exports = __webpack_public_path__ + "static/media/agriculture-min.6cec536e.jpg";